const BASE = "https://thainotarylaw.com";
export const VISA_HREFLANG_LINKS = [
  { rel: "alternate", hrefLang: "th-TH", href: `${BASE}/visa` },
  { rel: "alternate", hrefLang: "en", href: `${BASE}/en/visa` },
  { rel: "alternate", hrefLang: "zh", href: `${BASE}/zh/visa` },
  { rel: "alternate", hrefLang: "ja", href: `${BASE}/ja/visa` },
  { rel: "alternate", hrefLang: "ko", href: `${BASE}/ko/visa` },
  { rel: "alternate", hrefLang: "vi", href: `${BASE}/vi/visa` },
  { rel: "alternate", hrefLang: "id", href: `${BASE}/id/visa` },
  { rel: "alternate", hrefLang: "x-default", href: `${BASE}/visa` },
] as const;
